module.exports = __webpack_public_path__ + "static/media/donate.b28c77cc.svg";